import { http } from "../utils/http";
export const getHomeInfo = (data) =>
  http.post("/weilan/api/count/info/getHomeInfo", data);
export const siteDistributionInfo = (data) =>
  http.get("/weilan/api/home/page/siteDistributionInfo", data);
export const siteStatisticsInfo = (data) =>
  http.post("/weilan/api/home/page/siteStatisticsInfo", data);
